module.exports = __webpack_public_path__ + "media/images/airtel-money1-77d601bca9d9f0a532a4828a8200e3e2.png";